import axios from 'axios';
import storageManager from '../utils/storageManager';

// Set REACT_APP_API_BASE_URL in frontend/.env to point at another backend
// (e.g. http://localhost:5000/api). Unset = production, so builds are unchanged.
const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.jucopipeline.ai/api';

// The same back-end server without the /api suffix (used for real-time chat).
export const SERVER_URL = BASE_URL.replace(/\/api\/?$/, '');

let isLoggingOut = false;

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = storageManager.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = storageManager.getRefreshToken();
        if (refreshToken) {
          const response = await axios.post(`${BASE_URL}/auth/refresh`, {
            refreshToken,
          });

          const { token } = response.data;
          storageManager.setToken(token);

          originalRequest.headers.Authorization = `Bearer ${token}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        // Refresh failed — session expired
      }

      // Show alert and logout — only once
      if (!isLoggingOut) {
        isLoggingOut = true;
        alert('Your session has expired. Please login again.');
        try {
          await axios.post(`${BASE_URL}/auth/logout`, {}, {
            headers: { Authorization: `Bearer ${storageManager.getToken()}` }
          });
        } catch (_) {
          // Ignore logout errors
        }
        storageManager.clearAll();
        window.location.href = '/auth/login';
      }
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default api;
export { BASE_URL };
